import * as React from 'react';
import Typography from '@mui/material/Typography';

export default function Copyright(props) {
  return (
    <Typography
      variant="body2"
      align="center"
      {...props}
      sx={[
        {
          color: 'text.secondary',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      {'Copyright © '}
        MuscleHead s.r.o.
      {' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
